import {CSSProperties, memo, ReactNode} from 'react';
import {InternalStandardProps, SvgIconProps, Tooltip, TooltipProps} from '@mui/material'
import {Help as HelpIcon} from '@mui/icons-material'

type OptionalTooltipProps = InternalStandardProps<TooltipProps, 'title'>;

interface Props extends InternalStandardProps<OptionalTooltipProps, 'children'> {
    tag?: 'p' | 'div' | 'span',
    className?: string,
    style?: CSSProperties,
    children?: ReactNode,
    color?: SvgIconProps['color'],
    size?: SvgIconProps['fontSize'],
    iconSize?: string,
    tooltip: string,
    IconProps?: SvgIconProps,
}

const TooltipBadge = memo(({tooltip='', tag='span', className, style, children, color, size='inherit', iconSize, IconProps={}, ...props}:Props) => {
    const CustomTag = tag;

    return (
        <Tooltip {...props} title={tooltip}>
            <CustomTag className={className} style={{cursor: 'pointer', ...style}}>
                {children ? children : (<HelpIcon {...IconProps} fontSize={size} color={color} sx={{
                    fontSize: iconSize,
                    ...IconProps?.sx
                }}/>)}
            </CustomTag>
        </Tooltip>
    )
})

export default TooltipBadge;